export type BorderRadius = "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "none" | "full" | "default";

export type BorderRadiusMap = {
  [key in BorderRadius]: string;
};

export const borderRadiusMap = {
  /** 0.125rem (2px) */
  sm: "rounded-sm",
  /** 0.25rem (4px) */
  default: "rounded",
  /** 0.375rem (6px) */
  md: "rounded-md",
  /** 0.5rem (8px) */
  lg: "rounded-lg",
  /** 0.75rem (12px) */
  xl: "rounded-xl",
  /** 1rem (16px) */
  "2xl": "rounded-2xl",
  /** 1.5rem (24px) */
  "3xl": "rounded-3xl",
  /** 2rem (32px) */
  "4xl": "rounded-4xl",
  /** 0 */
  none: "rounded-none",
  /** 100% */
  full: "rounded-full",
} as const;

export type Border = "none" | "default";

export type BorderStyle = "solid" | "dashed" | "dotted";

export const borderMap = {
  none: "border-0",
  default: "border",
} as const;

export const borderStyleMap = {
  solid: "border-solid",
  dashed: "border-dashed",
  dotted: "border-dotted",
} as const;
